import { useState } from "react";
import { StatusPill } from "../../components/ui/StatusPill";
import { useChangeLeadStatus } from "../activities/api";

const STATUSES = [
  "new",
  "interested",
  "follow_up",
  "not_interested",
  "converted",
  "lost",
] as const;

interface Props {
  workspaceSlug: string | null;
  leadId: string;
  status: string;
}

export function StatusChanger({ workspaceSlug, leadId, status }: Props) {
  const change = useChangeLeadStatus(workspaceSlug);
  const [open, setOpen] = useState(false);

  return (
    <span className="status-changer">
      <button
        type="button"
        className="status-trigger"
        onClick={() => setOpen((v) => !v)}
      >
        <StatusPill status={status} />
        <span className="caret">▾</span>
      </button>
      {open ? (
        <ul className="status-menu" onMouseLeave={() => setOpen(false)}>
          {STATUSES.filter((s) => s !== status).map((s) => (
            <li key={s}>
              <button
                type="button"
                onClick={async () => {
                  await change.mutateAsync({ leadId, status: s });
                  setOpen(false);
                }}
              >
                Move to <StatusPill status={s} />
              </button>
            </li>
          ))}
        </ul>
      ) : null}
    </span>
  );
}
